import { render, staticRenderFns } from "./bscroll.vue?vue&type=template&id=3c0791ff&scoped=true&"
import script from "./bscroll.vue?vue&type=script&lang=js&"
export * from "./bscroll.vue?vue&type=script&lang=js&"
import style0 from "./bscroll.vue?vue&type=style&index=0&id=3c0791ff&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0791ff",
  null
  
)

export default component.exports